type SalesMemberData = {
  reference: string;
  fullName: string;
}

export class SalesMember {
  reference: string;
  fullName: string;

  constructor(salesMember: SalesMemberData) {
    this.fullName = salesMember.fullName;
    this.reference = salesMember.reference;
  }

  isSame(other: SalesMember): boolean {
    return other && this.reference === other.reference;
  }

  static parse(salesMemberData: SalesMemberData) {
    return new SalesMember(salesMemberData);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesMembers/domain/SalesMember.js